import { call, put, takeEvery, takeLatest } from 'redux-saga/effects';
import { emailApi } from '../../../api/emailApi';
import { IBaseResponeModel } from '../../../models/response/base-response';
import { IEmail } from '../../../models/response/email/IEmail';
import { eEmailActionTypeIds, IEmailActionTypes } from '../../action-types/email/IEmailActionTypes';
import { actions } from '../../actions/actionsWrapper';
import { apiWrapper } from '../../../api/apiWrapper';
import { EmailSelectedRequest } from '../../../models/request/email/EmailSelectedRequest';
export function* emailSaga(): any {
    yield takeEvery(eEmailActionTypeIds.LOAD_START, loadWorker)
    yield takeEvery(eEmailActionTypeIds.SAVE_START, saveWorker)
    yield takeEvery(eEmailActionTypeIds.DELETE_START, deleteWorker)
    yield takeEvery(eEmailActionTypeIds.APPROVE_START, approveWorker)
    yield takeEvery(eEmailActionTypeIds.REJECT_START, rejectWorker)

}

function* loadWorker(): any {
    const res: IBaseResponeModel = yield call(emailApi.selectAll)
    if (res.is_success) {
        yield put(actions.emailWrapper.email.LOAD_SUCCCES(res.data))
    } else {
        yield put(actions.emailWrapper.email.LOAD_ERROR(res.message ?? "Error"))
    }
}

function* saveWorker(action: IEmailActionTypes): any {
    const payload = action.payload as IEmail;
    let res: IBaseResponeModel;
    if (payload.id > 0) {
        res = yield call(apiWrapper.email.email.update, payload)
    } else {
        res = yield call(apiWrapper.email.email.insert, payload)
    }
    if (res.is_success) {
        yield put(actions.emailWrapper.email.SAVE_SUCCESS(res.data))
    } else {
        yield put(actions.emailWrapper.email.SAVE_ERROR(res.message ?? "Error"))
    }
}
function* deleteWorker(action: IEmailActionTypes): any {
    const payload: number = action.payload as number;
    const res: IBaseResponeModel = yield call(apiWrapper.email.email.delete, payload)
    if (res.is_success) {
        yield put(actions.emailWrapper.email.DELETE_SUCESS(undefined))
    } else {
        yield put(actions.emailWrapper.email.DELETE_ERROR(res.message ?? "Error"))
    }
}
function* approveWorker(action: IEmailActionTypes): any {
    debugger
    const payload: EmailSelectedRequest = {
        EmailIds: action.payload as number[]
    }
    const res: IBaseResponeModel = yield call(apiWrapper.email.email.ApproveEmail, payload)
    if (res.is_success) {
        yield put(actions.emailWrapper.email.APPROVE_SUCCESS(undefined))
    } else {
        yield put(actions.emailWrapper.email.APPROVE_ERROR(res.message ?? "Error"))
    }
}
function* rejectWorker(action: IEmailActionTypes): any {
    const payload: EmailSelectedRequest = {
        EmailIds: action.payload as number[]
    }
    const res: IBaseResponeModel = yield call(apiWrapper.email.email.RejectEmail, payload)
    if (res.is_success) {
        yield put(actions.emailWrapper.email.REJECT_SUCCESS(undefined))
    } else {
        yield put(actions.emailWrapper.email.REJECT_ERROR(res.message ?? "Error"))
    }
}